<template>
    <v-list-item>
        <v-list-item-content>
            <v-list-item-subtitle>{{ reply.field.title }}</v-list-item-subtitle>
            <v-row dense>
                <v-col cols="12">
                    <img
                            width="100%"
                            style="max-width: 640px;"
                            :src="reply.field_signature.url">
                </v-col>
            </v-row>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
    export default {
        name: "FieldSignatureReply",
        props: {
            reply: {type: Object, default: () => {}}
        }
    }
</script>

<style scoped>

</style>